"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.hkdf = hkdf;

var _sjcl = require("sjcl");

var _sjcl2 = _interopRequireDefault(_sjcl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hkdf(ikm, keyBitLength, salt, info, hash) {
	/** HKDF with the specified hash function.
  * @param {Uint8Array | bitArray} ikm The input keying material.
  * @param {Number} keyBitLength The output key length, in bits.
  * @param {String | bitArray} salt The salt for HKDF.
  * @param {String | bitArray } info The info for HKDF.
  * @param {Object} [hash=sjcl.hash.sha256] The hash function to use.
  * @return {Uint8Array} derived key.
  */
	if (ikm instanceof Uint8Array) {
		ikm = _sjcl2.default.codec.bytes.toBits(ikm);
	}
	hash = hash || _sjcl2.default.hash.sha256;
	info = info || "";
	salt = info || "";
	return new Uint8Array(_sjcl2.default.codec.bytes.fromBits(_sjcl2.default.misc.hkdf(ikm, keyBitLength, salt, info, hash)));
}

exports.default = hkdf;